import { render, staticRenderFns } from "./RegisterReturn.vue?vue&type=template&id=cc2367a0&scoped=true&"
import script from "./RegisterReturn.vue?vue&type=script&lang=js&"
export * from "./RegisterReturn.vue?vue&type=script&lang=js&"
import style0 from "./RegisterReturn.vue?vue&type=style&index=0&id=cc2367a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2367a0",
  null
  
)

export default component.exports